import React, { useState, useEffect, useRef } from "react";
import { message, Card, Row, Col, Progress, Divider } from "antd";
import "bootstrap/dist/css/bootstrap.min.css";
import { getCohorte } from "../../../../services/Producto_3/Uniminuto/uniminutosServices"
import "../Uniminuto/Uniminuto.css"
import RadarChart from "../../../poaReporte/Graficos/RadarChart";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChalkboardTeacher, faDesktop, faUser } from '@fortawesome/free-solid-svg-icons';



function AnimatedProgress({
    type = "circle",
    finalValue = 0,
    format,
    strokeColor,
    progressInfoPosition
}) {
    const [currentValue, setCurrentValue] = React.useState(0);

    React.useEffect(() => {
        // Reiniciamos a 0 cada vez que 'finalValue' cambie
        setCurrentValue(0);

        let tempValue = 0;
        const interval = setInterval(() => {
            tempValue += 1;         // Incrementa de 1 en 1
            if (tempValue >= finalValue) {
                tempValue = finalValue;
                clearInterval(interval);
            }
            setCurrentValue(tempValue);
        }, 15); // ~15 ms para ~66fps

        return () => clearInterval(interval);
    }, [finalValue]); // Cuando cambie finalValue, reinicia y re-aniima

    return (
        <Progress
            type={type}
            percent={currentValue}
            format={format}
            strokeColor={strokeColor}

        />
    );
}


const GraficaUniminuto = () => {
    const modalRef = useRef();
    // Estado para la tabla



    // Estado para almacenar los indicadores de sesiones y participación
    const [indicadores, setIndicadores] = useState({
        // Número total de cohortes registradas
        numCohortes: 0,
        // Conteo de sesiones por modalidad
        numSesionesVirtuales: 0,
        numSesionesAutonomas: 0,
        numSesionesPresenciales: 0,
        // Total de participantes por modalidad
        totalParticipantesPresenciales: 0,
        totalParticipantesVirtuales: 0,
        totalParticipantesAutonomas: 0,
        // Porcentaje de participación total de hombres y mujeres en todas las sesiones
        porc_Htot: 0,
        porc_Mtot: 0,
        // Participación de mujeres y hombres en sesiones presenciales
        participacionMujeresPresenciales: 0,
        participacionHombresPresenciales: 0,
        // Participación de mujeres y hombres en sesiones virtuales
        participacionMujeresVirtuales: 0,
        participacionHombresVirtuales: 0,
        // Participación de mujeres y hombres en sesiones autónomas
        participacionMujeresAutonomas: 0,
        participacionHombresAutonomas: 0,
        // Total de sesiones realizadas
        numSesiones: 0,
        // Total de asistentes por género en todas las modalidades
        asistentesHombres: 0,
        asistentesMujeres: 0,
        // Asistentes en sesiones virtuales por género
        asistentesHombresV: 0,
        asistentesMujeresV: 0,
        // Porcentaje de asistentes en sesiones virtuales por género
        porc_asistentesHombresV: 0,
        porc_asistentesMujeresV: 0,
        // Asistentes en sesiones presenciales por género
        asistentesHombresP: 0,
        asistentesMujeresP: 0,
        // Porcentaje de asistentes en sesiones presenciales por género
        porc_asistentesHombresP: 0,
        porc_asistentesMujeresP: 0,
        // Asistentes en sesiones autónomas por género
        asistentesHombresA: 0,
        asistentesMujeresA: 0,
        // Porcentaje de asistentes en sesiones autónomas por género
        porc_asistentesHombresA: 0,
        porc_asistentesMujeresA: 0,
    });

    // Carga de Datos en la tabla
    const fetchData = async () => {
        try {
            const response = await getCohorte();
            if (response.status === 200 && response.success) {
                // Calculamos los indicadores globales a partir de la respuesta original
                let global = {
                    numCohortes: 0,
                    // Número de sesiones por tipo
                    numSesionesVirtuales: 0,
                    numSesionesAutonomas: 0,
                    numSesionesPresenciales: 0,
                    numSesiones: 0,
                    // Total de participantes por tipo de sesión
                    totalParticipantesVirtuales: 0,
                    totalParticipantesAutonomas: 0,
                    totalParticipantesPresenciales: 0,
                    // Totales de asistentes por género
                    asistentesHombres: 0,
                    asistentesMujeres: 0,
                    // Totales de asistentes por género en cada tipo de sesión
                    sumaHombresVirtuales: 0,
                    sumaMujeresVirtuales: 0,
                    sumaHombresAutonomas: 0,
                    sumaMujeresAutonomas: 0,
                    sumaHombresPresenciales: 0,
                    sumaMujeresPresenciales: 0,
                    // Porcentajes de asistentes por género
                    porcentajeasistentesHombres: 0,
                    porcentajeasistentesMujeres: 0,
                    porcentajeasistentesHombresV: 0,
                    porcentajeasistentesMujeresV: 0,
                    porcentajeasistentesHombresA: 0,
                    porcentajeasistentesMujeresA: 0,
                    porcentajeasistentesHombresP: 0,
                    porcentajeasistentesMujeresP: 0,
                };
                response.data.forEach((reg) => {
                    global.numCohortes += 1;
                    const jsonData = reg.JSONDataCohorte;
                    // Filtrar sesiones por tipo
                    const sesionesVirtuales = jsonData.detalleSesiones.filter(sesion => sesion.modalidadSesion === "Virtual" && sesion.numSesion != null) || [];
                    const numSesionesUnicasVirtuales = new Set(sesionesVirtuales.map(s => s.numSesion));
                    const totalNumSesionVirtual = numSesionesUnicasVirtuales.size;
                    const sesionesAutonomas = jsonData.detalleSesiones.filter(sesion => sesion.modalidadSesion === "Autónomo" && sesion.numSesion != null) || [];
                    const numSesionesUnicasAutonomas = new Set(sesionesAutonomas.map(s => s.numSesion));
                    const totalNumSesionAutonomas = numSesionesUnicasAutonomas.size;
                    const sesionesPresenciales = jsonData.detalleSesiones.filter(sesion => sesion.modalidadSesion === "Presencial" && sesion.numSesion != null) || [];
                    const numSesionesUnicasPresenciales = new Set(sesionesPresenciales.map(s => s.numSesion));
                    const totalNumSesionPresenciale = numSesionesUnicasPresenciales.size;
                    // Sumar número de sesiones por tipo
                    global.numSesionesVirtuales += totalNumSesionVirtual;
                    global.numSesionesAutonomas += totalNumSesionAutonomas;
                    global.numSesionesPresenciales += totalNumSesionPresenciale;
                    // Sumar total de asistentes por tipo de sesión
                    global.totalParticipantesVirtuales += sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0);
                    global.totalParticipantesAutonomas += sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0);
                    global.totalParticipantesPresenciales += sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0);
                    // Sumar asistentes hombres y mujeres en cada tipo de sesión
                    global.sumaHombresVirtuales += sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    global.sumaMujeresVirtuales += sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                    global.sumaHombresAutonomas += sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    global.sumaMujeresAutonomas += sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                    global.sumaHombresPresenciales += sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    global.sumaMujeresPresenciales += sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                });
                // Calcula totales adicionales
                global.numSesiones = global.numSesionesVirtuales + global.numSesionesAutonomas + global.numSesionesPresenciales;
                global.asistentesHombres = global.sumaHombresVirtuales + global.sumaHombresAutonomas + global.sumaHombresPresenciales;
                global.asistentesMujeres = global.sumaMujeresVirtuales + global.sumaMujeresAutonomas + global.sumaMujeresPresenciales;
                // Calcula totales y porcentajes
                const totalVirtuales = global.totalParticipantesVirtuales;
                const totalAutonomas = global.totalParticipantesAutonomas;
                const totalPresenciales = global.totalParticipantesPresenciales;
                const totalParticipantes = totalVirtuales + totalAutonomas + totalPresenciales;
                const calcularPorcentaje = (total, valor) => (total > 0 ? ((valor / total) * 100).toFixed(2) : "0.00");
                // Participación en sesiones virtuales
                const participacionHombresVirtuales = calcularPorcentaje(totalVirtuales, global.sumaHombresVirtuales);
                const participacionMujeresVirtuales = calcularPorcentaje(totalVirtuales, global.sumaMujeresVirtuales);
                // Participación en sesiones autónomas
                const participacionHombresAutonomas = calcularPorcentaje(totalAutonomas, global.sumaHombresAutonomas);
                const participacionMujeresAutonomas = calcularPorcentaje(totalAutonomas, global.sumaMujeresAutonomas);
                // Participación en sesiones presenciales
                const participacionHombresPresenciales = calcularPorcentaje(totalPresenciales, global.sumaHombresPresenciales);
                const participacionMujeresPresenciales = calcularPorcentaje(totalPresenciales, global.sumaMujeresPresenciales);
                // Porcentaje total de asistentes hombres y mujeres en todas las sesiones
                const porcentajeasistentesHombres = calcularPorcentaje(totalParticipantes, global.asistentesHombres);
                const porcentajeasistentesMujeres = calcularPorcentaje(totalParticipantes, global.asistentesMujeres);
                // Participantes Certificados
                const participantesCertificados = response.totalCertificados || 0;
                setIndicadores({
                    numCohortes: global.numCohortes,
                    numSesionesVirtuales: global.numSesionesVirtuales,
                    numSesionesAutonomas: global.numSesionesAutonomas,
                    numSesionesPresenciales: global.numSesionesPresenciales,
                    numSesiones: global.numSesiones,
                    totalParticipantesVirtuales: totalVirtuales,
                    totalParticipantesAutonomas: totalAutonomas,
                    totalParticipantesPresenciales: totalPresenciales,
                    asistentesHombres: global.asistentesHombres,
                    asistentesMujeres: global.asistentesMujeres,
                    participacionHombresVirtuales: Number(participacionHombresVirtuales),
                    participacionMujeresVirtuales: Number(participacionMujeresVirtuales),
                    participacionHombresAutonomas: Number(participacionHombresAutonomas),
                    participacionMujeresAutonomas: Number(participacionMujeresAutonomas),
                    participacionHombresPresenciales: Number(participacionHombresPresenciales),
                    participacionMujeresPresenciales: Number(participacionMujeresPresenciales),
                    asistentesHombresV: global.sumaHombresVirtuales,
                    asistentesMujeresV: global.sumaMujeresVirtuales,
                    asistentesHombresA: global.sumaHombresAutonomas,
                    asistentesMujeresA: global.sumaMujeresAutonomas,
                    asistentesHombresP: global.sumaHombresPresenciales,
                    asistentesMujeresP: global.sumaMujeresPresenciales,
                    porc_asistentesHombresV: participacionHombresVirtuales,
                    porc_asistentesMujeresV: participacionMujeresVirtuales,
                    porc_asistentesHombresA: participacionHombresAutonomas,
                    porc_asistentesMujeresA: participacionMujeresAutonomas,
                    porc_asistentesHombresP: participacionHombresPresenciales,
                    porc_asistentesMujeresP: participacionMujeresPresenciales,
                    porc_Htot: porcentajeasistentesHombres,
                    porc_Mtot: porcentajeasistentesMujeres,
                    participantesCertificados: participantesCertificados
                });
            } else {
                message.error("Error en la consulta de cohortes");
            }
        } catch (error) {
            console.error("Error fetching cohortes:", error);
            message.error("Error al obtener cohortes");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const maxCohortes = indicadores.numCohortes;
    const numCohortes = indicadores.numCohortes ?? 0;
    const percentCohortes = Math.round((numCohortes / maxCohortes) * 100);
    const totalAsistentes = (indicadores.totalParticipantesPresenciales + indicadores.totalParticipantesVirtuales + indicadores.totalParticipantesAutonomas) ?? 0;

    return (
        <div className="container">

            <div className="mb-4 d-flex justify-content-center">
                <h4>Resumen de cohortes y sesiones</h4>
            </div>
            <Row gutter={[16, 16]} className="mb-4 justify-content-center" >
                <Col
                    span={8}
                    style={{ borderRight: "1px solid #d9d9d9", paddingRight: "16px" }}
                >
                    <Card
                        style={{
                            height: "100%",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                        }}
                        styles={{
                            body: {
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }
                        }}
                    >

                        {/* Valor centrado verticalmente */}
                        <div style={{ flex: 1, display: "flex", alignItems: "center", marginBottom: "10px", marginTop: "20px" }}>
                            <FontAwesomeIcon icon={faChalkboardTeacher} style={{ fontSize: "50px", color: "#1890ff" }} />
                        </div>
                        <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                            <span style={{ fontSize: "40px", fontWeight: "bold", color: "#1890ff" }}>
                                {indicadores.numSesionesPresenciales}
                            </span>
                        </div>
                        <div style={{ marginTop: "-10px", paddingBottom: "10px" }}>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>
                                Sesiones Presenciales
                            </span>
                        </div>
                    </Card>
                </Col>
                <Col
                    span={8}
                    style={{ borderRight: "1px solid #d9d9d9", paddingRight: "16px" }}
                >
                    <Card
                        style={{
                            height: "100%",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                        }}
                        styles={{
                            body: {
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }
                        }}
                    >

                        <div style={{ flex: 1, display: "flex", alignItems: "center", marginBottom: "10px", marginTop: "20px" }}>
                            <FontAwesomeIcon icon={faDesktop} style={{ fontSize: "50px", color: "#1890ff" }} />
                        </div>
                        <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                            <span style={{ fontSize: "40px", fontWeight: "bold", color: "#1890ff" }}>
                                {indicadores.numSesionesVirtuales}
                            </span>
                        </div>
                        <div style={{ marginTop: "-10px", paddingBottom: "10px" }}>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>
                                Sesiones Virtuales
                            </span>
                        </div>
                    </Card>
                </Col>
                <Col
                    span={8}
                    style={{ borderRight: "1px solid #d9d9d9", paddingRight: "16px" }}
                >
                    <Card
                        style={{
                            height: "100%",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                        }}
                        styles={{
                            body: {
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }
                        }}
                    >

                        <div style={{ flex: 1, display: "flex", alignItems: "center", marginBottom: "10px", marginTop: "20px" }}>
                            <FontAwesomeIcon icon={faUser} style={{ fontSize: "50px", color: "#1890ff" }} />
                        </div>
                        <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                            <span style={{ fontSize: "40px", fontWeight: "bold", color: "#1890ff" }}>
                                {indicadores.numSesionesAutonomas}
                            </span>
                        </div>
                        <div style={{ marginTop: "-10px", paddingBottom: "10px" }}>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>
                                Sesiones Autónomas
                            </span>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Row gutter={[16, 16]} className="mb-4 justify-content-center" align="stretch">
                <Col span={6}>
                    <Card style={{ textAlign: 'center', paddingTop: '15px' }}>
                        <AnimatedProgress
                            type="circle"
                            finalValue={percentCohortes}
                            format={() => `${numCohortes}`}
                        />
                        <p style={{ marginTop: 16 }}>Número de Cohortes</p>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card style={{ textAlign: 'center', paddingTop: '15px' }}>
                        {(() => {
                            const totalSesiones = indicadores.numSesionesPresenciales + indicadores.numSesionesVirtuales + indicadores.numSesionesAutonomas;
                            return (
                                <AnimatedProgress
                                    type="circle"
                                    finalValue={totalSesiones}
                                    format={() => `${totalSesiones}`}
                                />
                            );
                        })()}
                        <p style={{ marginTop: 16 }}>Número de sesiones</p>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card style={{ textAlign: 'center', paddingTop: '15px' }}>
                        {(() => {
                            return (
                                <AnimatedProgress
                                    type="circle"
                                    finalValue={totalAsistentes}
                                    format={() => `${totalAsistentes}`}
                                />
                            );
                        })()}
                        <p style={{ marginTop: 16 }}>Total Asistencias</p>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card style={{ textAlign: 'center', paddingTop: '15px' }}>
                        {(() => {
                            const totalParticipantesCertificados = indicadores.participantesCertificados || 0;
                            return (
                                <AnimatedProgress
                                    type="circle"
                                    finalValue={totalParticipantesCertificados}
                                    format={() => `${totalParticipantesCertificados}`}
                                />
                            );
                        })()}
                        <p style={{ marginTop: 16 }}>Participantes Certificados</p>
                    </Card>
                </Col>
            </Row>
            <Row gutter={[16, 16]} className="mb-4 justify-content-center" align="stretch">
                <Col span={24}>
                    <Card style={{ textAlign: 'center', paddingTop: '15px' }}>
                        <h2>Participación de hombres y mujeres</h2>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "500px" }}>
                            <RadarChart
                                data={{
                                    asistentesMujeresV: indicadores.asistentesMujeresV,
                                    asistentesHombresV: indicadores.asistentesHombresV,
                                    asistentesMujeresA: indicadores.asistentesMujeresA,
                                    asistentesHombresA: indicadores.asistentesHombresA,
                                    asistentesMujeresP: indicadores.asistentesMujeresP,
                                    asistentesHombresP: indicadores.asistentesHombresP,
                                }}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default GraficaUniminuto;
